import { LootEntry } from '../data/monsters.config';
import { dungeonService } from './DungeonService';
import { TalentEffects } from './TalentEffectsService';
import { rollIndependentPool } from '../utils/loot-roll.utils';

/**
 * Loot multiplier from passive talents. Currently Pillard (+20% chance
 * and quantity). Composed with other multipliers (mod-rich-drop) at the
 * callsite.
 */
export function getTalentLootMultiplier(): number {
  return TalentEffects.hasPillard() ? 1.2 : 1;
}

/**
 * Rolls a loot table and materializes item drops on the ground.
 *
 * `multiplier` (default 1) multiplies BOTH the chance AND the quantity of
 * each entry. Used by the `mod-rich-drop` modifier (+50%). `firstKill` forces
 * `guaranteedOnFirstKill` entries to drop (boss reward grimoires).
 *
 * Trinkets and sketches are unlocked via designated sources
 * (cf. `docs/game-design/loot.md`), not via this table.
 */
export function rollLootTable(
  entries: LootEntry[],
  positions: Array<{ x: number; y: number }>,
  multiplier = 1,
  firstKill = false,
): void {
  if (positions.length === 0) {
    return;
  }
  const inventory = dungeonService.inventoryService;
  const drops = rollIndependentPool(entries, { multiplier, firstKill });
  let posIdx = 0;
  for (const drop of drops) {
    const pos = positions[posIdx % positions.length];
    inventory.dropItem(pos.x, pos.y, drop.itemId, drop.quantity);
    posIdx++;
  }
}
